import { NgModule } from '@angular/core';
import { FormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';

import { GlyphComponent } from './glyph.component';
import { GlyphRoutingModule } from './glyph.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    GlyphRoutingModule,
  ],
  exports: [
    GlyphComponent
  ],
  declarations: [
    GlyphComponent
  ],
})
export class GlyphModule { }
